module.exports = __webpack_public_path__ + "media/mansion.e0baac8f.jpg";